module.exports = __webpack_public_path__ + "static/media/step6.f4195ac0.png";